export default __webpack_public_path__ + "static/thumb-landscape-fe301f00794256e68e908322acbb9489.jpg";